import React from 'react';
import LocationTemplate from './LocationTemplate';

const SharpsburgPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Sharpsburg"
      stateName="North Carolina"
      countyName="Nash/Edgecombe/Wilson"
      zipCodes={["27878"]}
      latitude={35.8915}
      longitude={-77.8297}
      population={2059}
      historicalFact="Unusual for being located in three different counties simultaneously."
      nearbyTowns={[
        "Rocky Mount, NC",
        "Wilson, NC",
        "Nashville, NC",
        "Elm City, NC",
        "Saratoga, NC",
        "Tarboro, NC",
        "Battleboro, NC",
        "Red Oak, NC"
      ]}
    />
  );
};

export default SharpsburgPage;